import {
  FloatingFormItem,
  InputDecimal,
  InputText,
} from '@/components/_common';
import { PurchaseItemsFormValues } from '@/core/domain/purchase/purchaseItem/PurchaseItem.types';
import { useReleasePurchaseFormContext } from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/ReleasesPurchaseProvider';
import {
  Col,
  Divider,
  Form,
  FormInstance,
  Row,
  Select,
  Typography,
} from 'antd';
import { useIntl } from 'react-intl';

interface Props {
  form: FormInstance<PurchaseItemsFormValues>;
}

const CofinsForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();
  const { Title } = Typography;
  const { purchaseReadOnly } = useReleasePurchaseFormContext();

  return (
    <Form form={form} disabled={purchaseReadOnly}>
      <Row gutter={[12, 12]}>
        <Col span={24} lg={24}>
          <Title level={3} style={{ padding: 0 }}>
            {intl.formatMessage({
              id: 'purchases.details.itemsPurchase.cofins.taxRegime.title',
            })}
          </Title>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'cstCofins']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.cofins.taxRegime.cstCofins',
            })}
          >
            <InputText onlyNumber maxLength={2} />
          </FloatingFormItem>
        </Col>

        <Col span={24} lg={4} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'calcPercentCofins']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.cofins.taxRegime.calcPercentCofins',
            })}
            initialValue={1}
          >
            <Select
              style={{ width: '100' }}
              options={[
                {
                  value: 1,
                  label: intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.pis.taxRegime.calcPercentPis.percentage',
                  }),
                },
                {
                  value: 0,
                  label: intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.pis.taxRegime.calcPercentPis.value',
                  }),
                },
              ]}
            />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'quotaCofins']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.cofins.taxRegime.quotaCofins',
            })}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'baseCofins']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.cofins.taxRegime.baseCofins',
            })}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valueUnityCofins']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.cofins.taxRegime.valueUnityCofins',
            })}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valueCofins']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.cofins.taxRegime.valueCofins',
            })}
            initialValue={0}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Divider style={{ margin: 0 }} />

        <Col span={24} lg={24}>
          <Title level={3} style={{ padding: 0 }}>
            {intl.formatMessage({
              id: 'purchases.details.itemsPurchase.cofinsSt.taxRegime.title',
            })}
          </Title>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'calcPercentCofinsSt']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.cofinsSt.taxRegime.calcPercentCofinsSt',
            })}
            initialValue={1}
          >
            <Select
              style={{ width: '100' }}
              options={[
                {
                  value: 1,
                  label: intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.pis.taxRegime.calcPercentPis.percentage',
                  }),
                },
                {
                  value: 0,
                  label: intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.pis.taxRegime.calcPercentPis.value',
                  }),
                },
              ]}
            />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'quotaCofinsSt']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.cofinsSt.taxRegime.quotaCofinsSt',
            })}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valueUnityCofinsSt']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.cofinsSt.taxRegime.valueUnityCofinsSt',
            })}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'baseCofinsSt']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.cofinsSt.taxRegime.baseCofinsSt',
            })}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valueCofinsSt']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.cofinsSt.taxRegime.valueCofinsSt',
            })}
            initialValue={0}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default CofinsForm;
